exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".van-count-down {\n  color: #323233;\n  font-size: 0.186667rem;\n  line-height: 0.266667rem;\n}", "", {"version":3,"sources":["D:/WenZhouBangZhang/BZQD/node_modules/vant/es/count-down/D:/WenZhouBangZhang/BZQD/node_modules/vant/es/count-down/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,uBAAuB;EACvB,yBAAyB;CAC1B","file":"index.css","sourcesContent":[".van-count-down {\n  color: #323233;\n  font-size: 0.186667rem;\n  line-height: 0.266667rem;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./node_modules/px2rem-loader??ref--5-3!./node_modules/vant/es/count-down/index.css
// module id = vLD+
// module chunks = 143